import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import IntegrationMarketModal from "../Modal/IntegrationMarketModal";
import Field from "../../../../Pages/Settings/Content/Components/Field";
import Backdrop from "../../../UI/Backdrop/Backdrop";

import {
  RequestSetConfig,
  RequestDeleteConfig,
  RequestUpdateConfig,
} from "../../../../store/actions/integrationsActions";

import "./styles.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ImapemailSettings = ({ show, setShow, dataTmp = 0, setActiveInt }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [authority, setAuthority] = useState("");
  const [clientid, setClientid] = useState("");
  const [secret, setSecret] = useState("");
  const [secretid, setSecretid] = useState("");
  const [username, setUsername] = useState("");
  const [scope, setScope] = useState([]);
  const [password, setPassword] = useState("");
  const [confType, setConfType] = useState(false);
  const [server, setServer] = useState("");
  const [hoverBack, setHoverBack] = useState(false);

  const getConfig = useSelector((state) => state.integrations.getConfig);
  const setConfig = useSelector((state) => state.integrations.setConfig);
  const deleteConfig = useSelector((state) => state.integrations.deleteConfig);
  const loadingUpdate = useSelector((state) => state.integrations.loadingUpdate);
  const loading = useSelector((state) => state.integrations.loading);

  let query = useQuery();
  let confTmp = parseInt(dataTmp);

  const closePopupHandler = () => {
    cleanData();
    setShow(false);
    setActiveInt("");
    history.push("/integration-market");
  };

  const cleanData = () => {
    setAuthority("");
    setClientid("");
    setSecret("");
    setSecretid("");
    setUsername("");
    setScope("");
    setPassword("");
    setServer("");
  };

  useEffect(() => {
    if (query.get("t") === "add") {
      setConfType(true);
    } else if (query.get("t") === null) {
      setHoverBack(false);
      cleanData();
    } else {
      setConfType(false);
    }
  }, [query]);

  useEffect(() => {
    if (deleteConfig === "Success" && query.get("conf") === "imapemail" && !loadingUpdate) {
      cleanData();
    }
  }, [deleteConfig]);

  useEffect(() => {
    if (setConfig === "Success" && query.get("conf") === "imapemail" && !loadingUpdate) {
      cleanData();
    }
  }, [setConfig]);

  useEffect(() => {
    if (query.get("conf") === "imapemail") {
      if (getConfig) {
        const configData = getConfig.config[confTmp];
        if (configData) {
          setAuthority(configData?.authority);
          setClientid(configData?.client_id);
          setSecret(configData?.secret);
          setSecretid(configData?.["secret-id"]);
          setUsername(configData?.username);
          setScope(configData?.scope);
          setPassword(configData?.password);
          setServer(configData?.server);
        }
      }
    }
  }, [getConfig, confTmp]);

  const addConfig = () => {
    const config = {
      authority: authority,
      client_id: clientid,
      scope: scope,
      secret: secret,
      ["secret-id"]: secretid,
      username: username,
      password: password,
      server: server,
      bulk: 16,
      ssl: 1,
    };
    const configString = JSON.stringify(config);
    const data = { appname: "imapemail", config: configString };

    dispatch(RequestSetConfig(data));
  };

  const updateConfigData = () => {
    if (authority && clientid && secret && secretid && username && password && server && scope) {
      const config = {
        authority: authority,
        client_id: clientid,
        scope: scope,
        secret: secret,
        ["secret-id"]: secretid,
        username: username,
        password: password,
        server: server,
        bulk: 16,
        ssl: 1,
      };
      const configString = JSON.stringify(config);
      const data = {
        appname: "imapemail",
        config: configString,
        mountpoint: getConfig?.config[confTmp]?.authority,
      };

      dispatch(RequestUpdateConfig(data));
    } else {
      console.log("error");
      // console.log(
      //   authority && clientid && secret && secretid && username && password && server && scope,
      // );
    }
  };

  const delConfig = () => {
    dispatch(
      RequestDeleteConfig({
        inttype: "imapemail",
        mountpoint: getConfig?.config[confTmp]?.authority,
      }),
    );
  };

  return show ? (
    <IntegrationMarketModal
      title="Imap Email"
      onBack={() => history.push("/integration-market?bck=" + query.get("conf"))}
      onClose={closePopupHandler}>
      <div className="imapemail-settings">
        <div className="flex flex-align-items-center">
          <div className="flex-column m-r-10">
            <Field
              label="Authority"
              width="180px"
              value={authority}
              onChange={(e) => setAuthority(e.target.value)}
              placeholder="Enter authority"
            />
          </div>
          <div className="flex-column m-r-10">
            <Field
              label="Client Id"
              width="180px"
              value={clientid}
              onChange={(e) => setClientid(e.target.value)}
              placeholder="Enter client id"
            />
          </div>
          <div className="flex-column">
            <Field
              label="Secret"
              width="180px"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              placeholder="Enter secret"
            />
          </div>
        </div>

        <div className="flex flex-align-items-center m-t-20">
          <div className="flex-column m-r-10">
            <Field
              label="Secret Id"
              width="180px"
              value={secretid}
              onChange={(e) => setSecretid(e.target.value)}
              placeholder="Enter secret id"
            />
          </div>
          <div className="flex-column m-r-10">
            <Field
              label="Username"
              width="180px"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
            />
          </div>
          <div className="flex-column">
            <Field
              label="Password"
              width="180px"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
        </div>

        <div className="flex flex-align-items-center m-t-20">
          <div className="flex-column m-r-10">
            <Field
              label="Server"
              width="180px"
              value={server}
              onChange={(e) => setServer(e.target.value)}
              placeholder="Enter server"
            />
          </div>
          <div className="flex-column">
            <Field
              label="Scope"
              width="180px"
              value={scope}
              onChange={(e) => setScope(e.target.value)}
              placeholder="Enter scope"
            />
          </div>
        </div>
      </div>

      <div className="integration-market-modal__action">
        {confType ? (
          <button onClick={addConfig} className="primary-button">
            Add Config
          </button>
        ) : (
          <>
            <button onClick={updateConfigData} className="primary-button">
              Update
            </button>
            <button onClick={delConfig} className="danger-button">
              Delete
            </button>
          </>
        )}
      </div>

      {(loading || loadingUpdate) && query.get("conf") === "imapemail" && (
        <Backdrop show={loading || loadingUpdate} message="Please wait..." />
      )}
    </IntegrationMarketModal>
  ) : null;
};

export default ImapemailSettings;
